import { render, staticRenderFns } from "./CommonProblem.vue?vue&type=template&id=808097f8"
import script from "./CommonProblem.vue?vue&type=script&lang=js"
export * from "./CommonProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports